import React, { useEffect, useState } from 'react';

const EmailSettingsForm = ({ onSubmit, onTest, onCancel, initialData }) => {
  const [formData, setFormData] = useState({
    email_provider: 'gmail',
    smtp_server: 'smtp.gmail.com',
    smtp_port: 587,
    sender_email: '',
    sender_password: ''
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (initialData) {
      setFormData({
        email_provider: initialData.email_provider || 'gmail',
        smtp_server: initialData.smtp_server || 'smtp.gmail.com',
        smtp_port: initialData.smtp_port || 587,
        sender_email: initialData.sender_email || '',
        sender_password: '' // 보안상 비밀번호는 초기값으로 설정하지 않음
      });
    }
  }, [initialData]);

  const emailProviders = {
    gmail: {
      name: 'Gmail',
      server: 'smtp.gmail.com',
      port: 587
    },
    naver: {
      name: 'Naver',
      server: 'smtp.naver.com',
      port: 587
    },
    daum: {
      name: 'Daum',
      server: 'smtp.daum.net',
      port: 465
    },
    outlook: {
      name: 'Outlook',
      server: 'smtp-mail.outlook.com',
      port: 587
    },
    custom: {
      name: '기타',
      server: '',
      port: 587
    }
  };

  const handleProviderChange = (provider) => {
    const providerConfig = emailProviders[provider];
    setFormData({
      ...formData,
      email_provider: provider,
      smtp_server: providerConfig.server,
      smtp_port: providerConfig.port
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    try {
      await onSubmit(formData);
    } catch (error) {
      console.error('이메일 설정 저장 실패:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTest = async () => {
    setIsLoading(true);
    
    try {
      await onTest(formData);
    } catch (error) {
      console.error('테스트 이메일 발송 실패:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          이메일 제공업체
        </label>
        <select
          value={formData.email_provider}
          onChange={(e) => handleProviderChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          {Object.entries(emailProviders).map(([key, provider]) => (
            <option key={key} value={key}>
              {provider.name}
            </option>
          ))}
        </select>
      </div>

      {formData.email_provider === 'custom' && (
        <>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              SMTP 서버
            </label>
            <input
              type="text"
              value={formData.smtp_server}
              onChange={(e) => setFormData({...formData, smtp_server: e.target.value})}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="smtp.example.com"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              SMTP 포트
            </label>
            <input
              type="number"
              value={formData.smtp_port}
              onChange={(e) => setFormData({...formData, smtp_port: parseInt(e.target.value)})}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="587"
              required
            />
          </div>
        </>
      )}

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          발신자 이메일
        </label>
        <input
          type="email"
          value={formData.sender_email}
          onChange={(e) => setFormData({...formData, sender_email: e.target.value})}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="your-email@gmail.com"
          required
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          비밀번호
        </label>
        <input
          type="password"
          value={formData.sender_password}
          onChange={(e) => setFormData({...formData, sender_password: e.target.value})}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="이메일 비밀번호 또는 앱 비밀번호"
          required
        />
                 <p className="text-xs text-gray-500 mt-1">
           Gmail의 경우 2단계 인증 후 생성한 앱 비밀번호를 사용하세요.
         </p>
         {formData.email_provider === 'gmail' && (
           <div className="mt-2 p-3 bg-blue-50 border border-blue-200 rounded-md">
             <h4 className="text-xs font-medium text-blue-800 mb-2">Gmail 앱 비밀번호 생성 방법</h4>
             <ol className="text-xs text-blue-700 space-y-1 list-decimal list-inside">
               <li>Google 계정 설정 → 보안 → 2단계 인증 활성화</li>
               <li>보안 → 앱 비밀번호 → "기타(맞춤 이름)" 선택</li>
               <li>앱 이름: "RentalHub" 입력</li>
               <li>생성된 16자리 비밀번호 복사 (공백 제거)</li>
             </ol>
             <a 
               href="https://myaccount.google.com/apppasswords" 
               target="_blank" 
               rel="noopener noreferrer"
               className="text-xs text-blue-600 hover:text-blue-800 underline mt-2 inline-block"
             >
               앱 비밀번호 생성 페이지 바로가기 →
             </a>
           </div>
         )}
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <h4 className="text-sm font-medium text-blue-800 mb-2">설정 정보</h4>
        <div className="text-sm text-blue-700 space-y-1">
          <p><strong>서버:</strong> {formData.smtp_server}</p>
          <p><strong>포트:</strong> {formData.smtp_port}</p>
          <p><strong>보안:</strong> {formData.smtp_port === 465 ? 'SSL' : 'TLS'}</p>
        </div>
      </div>

      <div className="flex justify-end space-x-3 pt-4">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
          disabled={isLoading}
        >
          취소
        </button>
        <button
          type="button"
          onClick={handleTest}
          className="px-4 py-2 text-sm font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-md hover:bg-blue-100"
          disabled={isLoading}
        >
          {isLoading ? '테스트 중...' : '테스트 발송'}
        </button>
        <button
          type="submit"
          className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-50"
          disabled={isLoading}
        >
          {isLoading ? '저장 중...' : '설정 저장'}
        </button>
      </div>
    </form>
  );
};

export default EmailSettingsForm;
